<template lang="html">
  <label class="prt-input">
    <slot />
    <input :class="{'single-char': singleChar, error}" :placeholder="placeholder" :style="{marginLeft: $slots.default ? '' : '0px'}" :type="type" :value="value" @input="handleInput">
    <slot name="after" />
  </label>
</template>

<script>
export default {
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value);
    },
  },
  props: {
    error: Boolean,
    placeholder: String,
    singleChar: Boolean,
    type: {
      type: String,
      default: 'text',
    },
    value: [String, Number],
  },
};
</script>

<style lang="stylus" scoped>
  @require '../../styles/colors'

  .prt-input
    display: flex
    width: calc(100% - 32px)
    max-width: 504px
    white-space: nowrap
    margin: 0 auto
    margin-bottom: 12px
    justify-content: space-between
    align-items: center

    input
      font-family: inherit
      font-size: inherit
      color: black-87
      background-color: white
      box-shadow: 0px 2px 4px black-12
      border-radius: 3px
      height: 40px
      width: 100%
      border: 1px solid white
      margin-left: 16px
      padding: 0 9px
      box-sizing: border-box
      text-overflow: ellipsis
      outline: none
      transition: box-shadow 200ms ease, border 200ms ease

      &[type="number"]
        -moz-appearance: textfield

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button
          -webkit-appearance: none
          margin: 0

      &.single-char
        width: 40px
        text-align: center

      &:focus
        box-shadow: 0 2px 4px positive
        border: 1px solid positive

      &.error
        box-shadow: 0 2px 4px negative
        border: 1px solid negative
        animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both

      @keyframes shake {
        10%, 90% {
          transform: translateX(-1px);
        }

        20%, 80% {
          transform: translateX(2px);
        }

        30%, 50%, 70% {
          transform: translateX(-4px);
        }

        40%, 60% {
          transform: translateX(4px);
        }
      }
</style>
